import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import EN from './translations/en.json';
import FR from './translations/fr.json';
import IT from './translations/it.json';
import DE from './translations/de.json';
import PT from './translations/pt.json';
import LanguageDetector from 'i18next-browser-languagedetector';

const options = {
    order: ['querystring', 'navigator'],
    lookupQuerystring: 'lng',
};

const resources = {
    en: { translation: EN },
    fr: { translation: FR },
    de: { translation: DE },
    it: { translation: IT },
    pt: { translation: PT },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        compatibilityJSON: 'v3',
        resources,
        detection: options,
        keySeparator: false,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        pluralSeparator: '_',
    });
export default i18n;
